import { Stack } from "@altimateai/lego";
import { getIconByDatastoreType } from "../../DatastoreImage";
import { DatastoreTypeEnum } from "../../../types";
import { Badge } from "@altimateai/lego";

interface DatastoreStepHeaderProps {
  /** When false (Site Administrator Explorer PAT), the header switches from
   * "hosting" copy (creator publishes here) to "locate" copy (we find the
   * workbooks the customer already uploaded). */
  canPublishWorkbooks?: boolean;
}

export const DatastoreStepHeader = ({
  canPublishWorkbooks = true,
}: DatastoreStepHeaderProps = {}) => {
  const icon = getIconByDatastoreType({
    datastoreType: DatastoreTypeEnum.TABLEAU,
    className: "al-w-10 al-h-10 al-mr-3",
  });

  return (
    <Stack direction="row" justify="between" className="al-items-center al-mb-6">
      <Stack direction="column">
        <h3>
          {canPublishWorkbooks
            ? "Select Parent Project for hosting Altimate Workbooks"
            : "Select Parent Project that hosts the Altimate Workbooks you uploaded"}
        </h3>
        <p className="al-text-gray-500">
          {canPublishWorkbooks
            ? "Workbooks are used to gather analytics data that is otherwise not available via Tableau API."
            : "Your PAT cannot publish workbooks, so the Altimate Workbooks must already exist on your Tableau site. Point us at the parent project where you uploaded them."}
        </p>
      </Stack>
      <Badge variant="default" className="al-m-2">
        <Stack direction="row" className="al-items-center al-p-2">
          {icon}
          <span className="al-text-sm">Tableau</span>
        </Stack>
      </Badge>
    </Stack>
  );
};
